import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { FolderServiceImpl } from './services/folder-service';
import { FolderInfoModelImpl } from './models/folder-info-model';
import { FolderPermissionModelImpl } from './models/folder-permission-model';
import { FolderSettingModelImpl } from './models/folder-setting-model';
import { FolderApi } from './types/folder-api.interface';
import { FolderInfoModel } from './types/folder-info-model.interface';
import { FolderPermissionModel } from './types/folder-permission-model.interface';
import { FolderService } from './types/folder-service.interface';
import { FolderSettingModel } from './types/folder-setting-model.interface';
import { FolderApiImpl } from './repository/folder-api';
import { FolderCapacityModel } from './types/folder-capacity-model.interface';
import { FolderCapacityModelImpl } from './models/folder-capacity-model';
import { FolderSettingService } from './types/folder-setting-service.interface';
import { FolderSettingServiceImpl } from './services/folder-setting-service';
import { FolderSortRepositoryImpl } from './repository/folder-sort-repository';
import { FolderSortRepository } from './repository/folder-sort-repository.interface';
import { FolderSortServiceImpl } from './services/folder-sort-service';
import { FolderSortService } from './services/folder-sort-service.interface';
export const folder = new ContainerModule(bind => {
    bind(FolderService).to(FolderServiceImpl);
    bind(FolderSettingService).to(FolderSettingServiceImpl);
    bind(FolderInfoModel).to(FolderInfoModelImpl);
    bind(FolderSettingModel).to(FolderSettingModelImpl);
    bind(FolderPermissionModel).to(FolderPermissionModelImpl);
    bind(FolderCapacityModel).to(FolderCapacityModelImpl);
    bind(FolderSortService).to(FolderSortServiceImpl);
    bind(FolderSortRepository).to(FolderSortRepositoryImpl);
    bind(FolderApi).to(FolderApiImpl);
});
